<template>

  <div class="user">
    <el-form size="small" ref="form" :model="form" label-width="150px">
   
      <el-form-item label="是否开启进销存" >
        <el-switch v-model="form.is_open"></el-switch>
      </el-form-item>

      <el-form-item label="网站域名：" prop="text">
            <el-input type='text'  v-model="form.website" class="max-w460"></el-input>
      </el-form-item>

      <el-form-item label="访问站点ID：" prop="text">
            <el-input type='text'  v-model="form.app_id" class="max-w460"></el-input>
      </el-form-item>

      <el-form-item label="账号：" prop="text">
            <el-input type='text'  v-model="form.api_account" class="max-w460"></el-input>
      </el-form-item>

      <el-form-item label="密钥：" prop="text">
            <el-input type='text'  v-model="form.api_secret" class="max-w460"></el-input>
      </el-form-item>


      <el-form-item label="查询间隔" prop="interval" :rules="[{required: true,message: ' '}]">
        <el-input v-model="form.interval" type="number" min=10 class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="每次更新数量" prop="num" :rules="[{required: true,message: ' '}]">
        <el-input v-model="form.num" type="number" min=10 max=100 class="max-w460"></el-input>
        <div>最大更新100条</div>
      </el-form-item>




    </el-form>



    <!--提交-->
    <div class="common-button-wrapper">
      <el-button size="small" type="primary" @click="onSubmit" :disabled="loading">保存</el-button>
    </div>
  </div>
</template>
<script>
import PsinkApi from '@/api/psin.js';
export default {
  data() {
    return {
      form: {
        is_open:false,
        api_account:"",
        api_secret:"",
        store_api_account:"",
        store_api_secret:"",
        website:"http://kangcai.xcx008.com/",
        app_id:"10016"

      },
      setting: [],
      loading: false
    };
  },
  created() {
    /*获取列表*/
    this.getSetting();
  },
  methods: {
    /*获取设置*/
    getSetting() {
      let self = this;
      let Params = {};
      PsinkApi.getSetting(Params, true)
        .then(data => {
          self.loading = false;
          self.form = data.data.vars.values;
          if(self.form.website.length ==0){
            self.form.website="http://kangcai.xcx008.com/";
          }
          if(self.form.app_id.length ==0){

            self.form.app_id="10016"
          }
       
        })
        .catch(error => {});
    },

    /*点击保存*/
    onSubmit() {
      let self = this;
      let params = self.form;
      self.loading = true;
      PsinkApi.saveSetting(params, true)
        .then(data => {
          self.loading = false;
          if (data.code == 1) {
            self.$message({
              message: '恭喜你，保存成功',
              type: 'success'
            });
            self.getSetting();
          } else {
            self.loading = false;
          }
        })
        .catch(error => {
          self.loading = false;
        });
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/psin/setting/getSetting.vue